import React, { Component } from 'react'
import { Link, NavLink, withRouter } from 'react-router-dom'
import IntlMessages from 'util/IntlMessages'
import { IfCustomer, IfSpecialist } from 'containers/IfLoginType'
import { connect } from 'react-redux'
import { linkguaProfile } from 'util/checkAuthentication'
import SweetAlert from 'react-bootstrap-sweetalert'
import CustomerDetails from '../../Linkgua/components/CustomerDetails'

class Menu extends Component {

  constructor() {
    super()
    this.state = {
      profileWarning: null
    }
  }

  componentDidMount () {
    const {history} = this.props

    const pathname = `#${history.location.pathname}`// get current path
    const mainMenu = document.getElementsByClassName('nav-item')
    for (let i = 0; i < mainMenu.length; i++) {
      mainMenu[i].onclick = function () {
        for (let j = 0; j < mainMenu.length; j++) {
          if (mainMenu[j].classList.contains('active')) {
            mainMenu[j].classList.remove('active')
          }
        }
        this.classList.toggle('active')
      }
    }
    const subMenuLi = document.getElementsByClassName('nav-arrow')
    for (let i = 0; i < subMenuLi.length; i++) {
      subMenuLi[i].onclick = function () {
        for (let j = 0; j < subMenuLi.length; j++) {
          if (subMenuLi[j].classList.contains('active')) {
            subMenuLi[j].classList.remove('active')
          }
        }
        this.classList.toggle('active')
      }
    }
    const activeLi = document.querySelector('a[href="' + pathname + '"]')// select current a element
    try {
      const activeNav = this.closest(activeLi, 'ul') // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('active')
      } else {
        this.closest(activeLi, 'li').classList.add('active')
      }
      const parentNav = this.closest(activeNav, '.nav-item')
      if (parentNav) {
        parentNav.classList.add('active')
      }

    } catch (e) {

    }

  }

  closest (el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
        if (typeof document.body[fn] == 'function') {
          matchesFn = fn
          return true
        }
        return false
      })

      let parent

      // traverse parents
      while (el) {
        parent = el.parentElement
        if (parent && parent[matchesFn](selector)) {
          return parent
        }
        el = parent
      }
    } catch (e) {

    }

    return null
  }

  render () {
    const checkProfile = (e) => {
      if(linkguaProfile(this.props.auth).profileStatus === 'initiated') {
        e.preventDefault()
        const hideMessage = () => {
          this.props.history.push('profile')
          return this.setState({profileWarning: null})
        }

         this.setState({
          profileWarning: <SweetAlert
            custom
            confirmBtnText={<IntlMessages id={'pages.project.create.needInfoAction'}/>}
            confirmBtnBsStyle={'success'}
            onConfirm={hideMessage}>
            <IntlMessages id={'pages.project.create.needInfo'}/>
          </SweetAlert>
        })
      }
    }
    return (
      <div className="app-main-menu d-none d-md-block">
        <ul className="navbar-nav navbar-nav-mega">

          <IfCustomer>
            <li className="nav-item">
              <NavLink to="/customer/dashboard">
                <span className="nav-text"><IntlMessages id="pages.customer.dashboard"/></span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/customer/projects">
                <span className="nav-text"><IntlMessages id="pages.customer.project.list"/></span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/customer/project/create" onClick={checkProfile}>
                <span className="nav-text bg-info text-white rounded p-3 ml-5"><IntlMessages id="pages.customer.project.createQuote"/></span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/customer/project/create" onClick={checkProfile}>
                <span className="nav-text bg-secondary text-white rounded p-3"><IntlMessages id="pages.customer.project.create"/></span>
              </NavLink>
            </li>
          </IfCustomer>

          <IfSpecialist>
            <li className="nav-item">
              <NavLink to="/specialist">
                <span className="nav-text"><IntlMessages id="pages.specialist.dashboard"/> </span>
              </NavLink>
            </li>
          </IfSpecialist>

        </ul>
        {this.state.profileWarning}
      </div>
    )
  }
}

const mapStateToProps = ({auth}) => {
  return {auth}
}

export default connect(mapStateToProps)(withRouter(Menu))



// WEBPACK FOOTER //
// ./components/Header/Menu.js